<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Новая активность</v-card-title>

        <v-container>
          <v-autocomplete v-model="form.companyID"
            autofocus
            :items="companiesItems"
            hint="Компания"
            :error-messages="verrCompanyID"/>
          <v-text-field v-model.trim="form.activityYear"
            persistent-hint
            placeholder="YYYY"
            maxlength="4"
            hint="Год" style="width: 100px"
            :error-messages="verrActivityYear"/>
        </v-container>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="$v.$invalid" :loading="loading" @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, numeric, between } from 'vuelidate/lib/validators'

export default {
  mixins: [ validationMixin ],
  props: [ 'companies' ],
  data: () => ({
    dialog: false,
    loading: false,
    form: {}
  }),
  validations: {
    form: {
      companyID: { required },
      activityYear: { required, numeric, between: between(new Date().getFullYear()-2, new Date().getFullYear()+1) }
    }
  },
  computed: {
    companiesItems () { return this.companies.map(cur => ({ value: cur[0], text: cur[1]})) },
    verrCompanyID () { return this.$v.form.companyID.$invalid ? 'Выберите компанию' : [] },
    verrActivityYear () { return this.$v.form.activityYear.$invalid ? 'Введите год' : [] }
  },
  methods: {
    create () {
      this.dialog = true
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      if ( this.$v.$invalid ) return
      this.loading = true
      api.post('activities/create', this.form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.dialog = false
        this.form = {}
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
